<div class="d-flex justify-content-center">
  <span class="score-text fw-bold me-3">{{ rating.text }}</span>
  <span>
    @for (circle of filledCircles; track circle) {
      <fa-icon [icon]="['fas', 'circle']"></fa-icon>
    }
    @for (circle of emptyCircles; track circle) {
      <fa-icon [icon]="['fal', 'circle']"></fa-icon>
    }
  </span>
</div>
